/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as TosRouteImport } from "./routes/tos"
import { Route as RecentChatsRouteImport } from "./routes/recent-chats"
import { Route as ProfileRouteImport } from "./routes/profile"
import { Route as PrivacyRouteImport } from "./routes/privacy"
import { Route as LegalRouteImport } from "./routes/legal"
import { Route as GuidelinesRouteImport } from "./routes/guidelines"
import { Route as DevRouteImport } from "./routes/dev"
import { Route as ChatRouteImport } from "./routes/chat"
import { Route as ChangelogRouteImport } from "./routes/changelog"
import { Route as IndexRouteImport } from "./routes/index"
import { Route as StudioUpdateRouteImport } from "./routes/studio/update"
import { Route as StudioImportRouteImport } from "./routes/studio/import"
import { Route as StudioCreateRouteImport } from "./routes/studio/create"
import { Route as SettingsResetPasswordRouteImport } from "./routes/settings/reset-password"
import { Route as SettingsProfileRouteImport } from "./routes/settings/profile"
import { Route as SettingsPreferenceRouteImport } from "./routes/settings/preference"
import { Route as SettingsPersonaRouteImport } from "./routes/settings/persona"
import { Route as SettingsAccountRouteImport } from "./routes/settings/account"
import { Route as CharacterCharacterIdRouteImport } from "./routes/character.$characterId"

const TosRoute = TosRouteImport.update({
  id: "/tos",
  path: "/tos",
  getParentRoute: () => rootRouteImport,
} as any)
const RecentChatsRoute = RecentChatsRouteImport.update({
  id: "/recent-chats",
  path: "/recent-chats",
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: "/profile",
  path: "/profile",
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: "/privacy",
  path: "/privacy",
  getParentRoute: () => rootRouteImport,
} as any)
const LegalRoute = LegalRouteImport.update({
  id: "/legal",
  path: "/legal",
  getParentRoute: () => rootRouteImport,
} as any)
const GuidelinesRoute = GuidelinesRouteImport.update({
  id: "/guidelines",
  path: "/guidelines",
  getParentRoute: () => rootRouteImport,
} as any)
const DevRoute = DevRouteImport.update({
  id: "/dev",
  path: "/dev",
  getParentRoute: () => rootRouteImport,
} as any)
const ChatRoute = ChatRouteImport.update({
  id: "/chat",
  path: "/chat",
  getParentRoute: () => rootRouteImport,
} as any)
const ChangelogRoute = ChangelogRouteImport.update({
  id: "/changelog",
  path: "/changelog",
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any)
const StudioUpdateRoute = StudioUpdateRouteImport.update({
  id: "/studio/update",
  path: "/studio/update",
  getParentRoute: () => rootRouteImport,
} as any)
const StudioImportRoute = StudioImportRouteImport.update({
  id: "/studio/import",
  path: "/studio/import",
  getParentRoute: () => rootRouteImport,
} as any)
const StudioCreateRoute = StudioCreateRouteImport.update({
  id: "/studio/create",
  path: "/studio/create",
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsResetPasswordRoute = SettingsResetPasswordRouteImport.update({
  id: "/settings/reset-password",
  path: "/settings/reset-password",
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsProfileRoute = SettingsProfileRouteImport.update({
  id: "/settings/profile",
  path: "/settings/profile",
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsPreferenceRoute = SettingsPreferenceRouteImport.update({
  id: "/settings/preference",
  path: "/settings/preference",
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsPersonaRoute = SettingsPersonaRouteImport.update({
  id: "/settings/persona",
  path: "/settings/persona",
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsAccountRoute = SettingsAccountRouteImport.update({
  id: "/settings/account",
  path: "/settings/account",
  getParentRoute: () => rootRouteImport,
} as any)
const CharacterCharacterIdRoute = CharacterCharacterIdRouteImport.update({
  id: "/character/$characterId",
  path: "/character/$characterId",
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute
  "/changelog": typeof ChangelogRoute
  "/chat": typeof ChatRoute
  "/dev": typeof DevRoute
  "/guidelines": typeof GuidelinesRoute
  "/legal": typeof LegalRoute
  "/privacy": typeof PrivacyRoute
  "/profile": typeof ProfileRoute
  "/recent-chats": typeof RecentChatsRoute
  "/tos": typeof TosRoute
  "/character/$characterId": typeof CharacterCharacterIdRoute
  "/settings/account": typeof SettingsAccountRoute
  "/settings/persona": typeof SettingsPersonaRoute
  "/settings/preference": typeof SettingsPreferenceRoute
  "/settings/profile": typeof SettingsProfileRoute
  "/settings/reset-password": typeof SettingsResetPasswordRoute
  "/studio/create": typeof StudioCreateRoute
  "/studio/import": typeof StudioImportRoute
  "/studio/update": typeof StudioUpdateRoute
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute
  "/changelog": typeof ChangelogRoute
  "/chat": typeof ChatRoute
  "/dev": typeof DevRoute
  "/guidelines": typeof GuidelinesRoute
  "/legal": typeof LegalRoute
  "/privacy": typeof PrivacyRoute
  "/profile": typeof ProfileRoute
  "/recent-chats": typeof RecentChatsRoute
  "/tos": typeof TosRoute
  "/character/$characterId": typeof CharacterCharacterIdRoute
  "/settings/account": typeof SettingsAccountRoute
  "/settings/persona": typeof SettingsPersonaRoute
  "/settings/preference": typeof SettingsPreferenceRoute
  "/settings/profile": typeof SettingsProfileRoute
  "/settings/reset-password": typeof SettingsResetPasswordRoute
  "/studio/create": typeof StudioCreateRoute
  "/studio/import": typeof StudioImportRoute
  "/studio/update": typeof StudioUpdateRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/": typeof IndexRoute
  "/changelog": typeof ChangelogRoute
  "/chat": typeof ChatRoute
  "/dev": typeof DevRoute
  "/guidelines": typeof GuidelinesRoute
  "/legal": typeof LegalRoute
  "/privacy": typeof PrivacyRoute
  "/profile": typeof ProfileRoute
  "/recent-chats": typeof RecentChatsRoute
  "/tos": typeof TosRoute
  "/character/$characterId": typeof CharacterCharacterIdRoute
  "/settings/account": typeof SettingsAccountRoute
  "/settings/persona": typeof SettingsPersonaRoute
  "/settings/preference": typeof SettingsPreferenceRoute
  "/settings/profile": typeof SettingsProfileRoute
  "/settings/reset-password": typeof SettingsResetPasswordRoute
  "/studio/create": typeof StudioCreateRoute
  "/studio/import": typeof StudioImportRoute
  "/studio/update": typeof StudioUpdateRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/changelog"
    | "/chat"
    | "/dev"
    | "/guidelines"
    | "/legal"
    | "/privacy"
    | "/profile"
    | "/recent-chats"
    | "/tos"
    | "/character/$characterId"
    | "/settings/account"
    | "/settings/persona"
    | "/settings/preference"
    | "/settings/profile"
    | "/settings/reset-password"
    | "/studio/create"
    | "/studio/import"
    | "/studio/update"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/"
    | "/changelog"
    | "/chat"
    | "/dev"
    | "/guidelines"
    | "/legal"
    | "/privacy"
    | "/profile"
    | "/recent-chats"
    | "/tos"
    | "/character/$characterId"
    | "/settings/account"
    | "/settings/persona"
    | "/settings/preference"
    | "/settings/profile"
    | "/settings/reset-password"
    | "/studio/create"
    | "/studio/import"
    | "/studio/update"
  id:
    | "__root__"
    | "/"
    | "/changelog"
    | "/chat"
    | "/dev"
    | "/guidelines"
    | "/legal"
    | "/privacy"
    | "/profile"
    | "/recent-chats"
    | "/tos"
    | "/character/$characterId"
    | "/settings/account"
    | "/settings/persona"
    | "/settings/preference"
    | "/settings/profile"
    | "/settings/reset-password"
    | "/studio/create"
    | "/studio/import"
    | "/studio/update"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ChangelogRoute: typeof ChangelogRoute
  ChatRoute: typeof ChatRoute
  DevRoute: typeof DevRoute
  GuidelinesRoute: typeof GuidelinesRoute
  LegalRoute: typeof LegalRoute
  PrivacyRoute: typeof PrivacyRoute
  ProfileRoute: typeof ProfileRoute
  RecentChatsRoute: typeof RecentChatsRoute
  TosRoute: typeof TosRoute
  CharacterCharacterIdRoute: typeof CharacterCharacterIdRoute
  SettingsAccountRoute: typeof SettingsAccountRoute
  SettingsPersonaRoute: typeof SettingsPersonaRoute
  SettingsPreferenceRoute: typeof SettingsPreferenceRoute
  SettingsProfileRoute: typeof SettingsProfileRoute
  SettingsResetPasswordRoute: typeof SettingsResetPasswordRoute
  StudioCreateRoute: typeof StudioCreateRoute
  StudioImportRoute: typeof StudioImportRoute
  StudioUpdateRoute: typeof StudioUpdateRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/tos": {
      id: "/tos"
      path: "/tos"
      fullPath: "/tos"
      preLoaderRoute: typeof TosRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/recent-chats": {
      id: "/recent-chats"
      path: "/recent-chats"
      fullPath: "/recent-chats"
      preLoaderRoute: typeof RecentChatsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/profile": {
      id: "/profile"
      path: "/profile"
      fullPath: "/profile"
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/privacy": {
      id: "/privacy"
      path: "/privacy"
      fullPath: "/privacy"
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/legal": {
      id: "/legal"
      path: "/legal"
      fullPath: "/legal"
      preLoaderRoute: typeof LegalRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/guidelines": {
      id: "/guidelines"
      path: "/guidelines"
      fullPath: "/guidelines"
      preLoaderRoute: typeof GuidelinesRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/dev": {
      id: "/dev"
      path: "/dev"
      fullPath: "/dev"
      preLoaderRoute: typeof DevRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/chat": {
      id: "/chat"
      path: "/chat"
      fullPath: "/chat"
      preLoaderRoute: typeof ChatRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/changelog": {
      id: "/changelog"
      path: "/changelog"
      fullPath: "/changelog"
      preLoaderRoute: typeof ChangelogRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/": {
      id: "/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/studio/update": {
      id: "/studio/update"
      path: "/studio/update"
      fullPath: "/studio/update"
      preLoaderRoute: typeof StudioUpdateRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/studio/import": {
      id: "/studio/import"
      path: "/studio/import"
      fullPath: "/studio/import"
      preLoaderRoute: typeof StudioImportRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/studio/create": {
      id: "/studio/create"
      path: "/studio/create"
      fullPath: "/studio/create"
      preLoaderRoute: typeof StudioCreateRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/settings/reset-password": {
      id: "/settings/reset-password"
      path: "/settings/reset-password"
      fullPath: "/settings/reset-password"
      preLoaderRoute: typeof SettingsResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/settings/profile": {
      id: "/settings/profile"
      path: "/settings/profile"
      fullPath: "/settings/profile"
      preLoaderRoute: typeof SettingsProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/settings/preference": {
      id: "/settings/preference"
      path: "/settings/preference"
      fullPath: "/settings/preference"
      preLoaderRoute: typeof SettingsPreferenceRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/settings/persona": {
      id: "/settings/persona"
      path: "/settings/persona"
      fullPath: "/settings/persona"
      preLoaderRoute: typeof SettingsPersonaRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/settings/account": {
      id: "/settings/account"
      path: "/settings/account"
      fullPath: "/settings/account"
      preLoaderRoute: typeof SettingsAccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/character/$characterId": {
      id: "/character/$characterId"
      path: "/character/$characterId"
      fullPath: "/character/$characterId"
      preLoaderRoute: typeof CharacterCharacterIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ChangelogRoute: ChangelogRoute,
  ChatRoute: ChatRoute,
  DevRoute: DevRoute,
  GuidelinesRoute: GuidelinesRoute,
  LegalRoute: LegalRoute,
  PrivacyRoute: PrivacyRoute,
  ProfileRoute: ProfileRoute,
  RecentChatsRoute: RecentChatsRoute,
  TosRoute: TosRoute,
  CharacterCharacterIdRoute: CharacterCharacterIdRoute,
  SettingsAccountRoute: SettingsAccountRoute,
  SettingsPersonaRoute: SettingsPersonaRoute,
  SettingsPreferenceRoute: SettingsPreferenceRoute,
  SettingsProfileRoute: SettingsProfileRoute,
  SettingsResetPasswordRoute: SettingsResetPasswordRoute,
  StudioCreateRoute: StudioCreateRoute,
  StudioImportRoute: StudioImportRoute,
  StudioUpdateRoute: StudioUpdateRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
